import { render, staticRenderFns } from "./UserWithBadge.vue?vue&type=template&id=668ded44&scoped=true"
import script from "./UserWithBadge.vue?vue&type=script&lang=js"
export * from "./UserWithBadge.vue?vue&type=script&lang=js"
import style0 from "./UserWithBadge.vue?vue&type=style&index=0&id=668ded44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ded44",
  null
  
)

export default component.exports